import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const itemDescription = css`
  margin-top: var(--space-150);

  ${breakpoints.to.desktop} {
    margin-top: var(--space-100);
  }
`;

export const itemContent = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 auto;
  padding: var(--space-300);
  a {
    margin-top: auto;
    color: var(--control-invert);
    background-color: rgba(255, 2555, 255, 0.16);
    &:hover {
      background-color: rgba(255, 2555, 255, 0.5);
    }
  }
  &.portrait {
    min-height: 192px;

    ${breakpoints.to.desktop} {
      min-height: 200px;
    }
  }
  &.landscape {
    ${breakpoints.only.largeDesktop} {
      min-width: 300px;
    }
    ${breakpoints.only.desktop} {
      min-width: 235px;
    }
  }
`;

export const itemButton = css`
  padding: var(--space-125) var(--space-250);
  margin-top: auto;
  background: rgba(255, 255, 255, 0.16);
  border-radius: var(--rounding-m);
  transition: background-color 0.3s;
`;
